import { render, staticRenderFns } from "./ImportarProdutosDialog.vue?vue&type=template&id=4ac9650d"
import script from "./ImportarProdutosDialog.vue?vue&type=script&lang=js"
export * from "./ImportarProdutosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports